import { render, staticRenderFns } from "./main-menu-new.vue?vue&type=template&id=472a41b8"
import script from "./main-menu-new.vue?vue&type=script&lang=js"
export * from "./main-menu-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports